import useGetChats from './useGetChats';
import useListenOnChats from './useListenOnChats';

export default function useChats() {
  const getChats = useGetChats();
  useListenOnChats(getChats);

  return {
    getChats,
  };
}
